import API from "lib/api"
import { GetStaticPaths, GetStaticProps, NextPage } from "next"
import { ProductHighlight, ProductPageProps } from "types"
import ProductPage from "../../partials/product-page"

const ComponentPage: NextPage<ProductPageProps> = ({
  product,
  recommendations,
  categories,
}) => {
  const highlights: ProductHighlight[] = []

  if (product.sales_unit) {
    highlights.push({
      type: "availability",
      title: "Batch Quantity",
      content: product.sales_unit,
    })
  }

  return (
    <ProductPage
      product={product}
      highlights={highlights}
      recommendations={recommendations}
      categories={categories}
    />
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const slugs = await API.services.index({
    type: "product",
    main_category_id: 4,
  })
  return {
    paths: slugs.map((slug: string) => ({
      params: {
        slug,
      },
    })),
    fallback: "blocking",
  }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  try {
    const [product, recommendations, categories] = await Promise.all([
      API.services.products.single(String(params?.slug)),
      API.services.products.recommendations(String(params?.slug)),
      API.services.categories.single("point-of-sale"),
    ])

    return {
      props: {
        product,
        recommendations,
        categories,
      },
      revalidate: 24 * 60 * 60,
    }
  } catch (error: any) {
    if (error.status === 404) {
      return {
        notFound: true,
        revalidate: 24 * 60 * 60,
      }
    }
    throw error
  }
}

export default ComponentPage
